var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Installer-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-settings",
    transform: "translate(-38.000000, -422.000000)",
    fill: "#00142D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1188",
    transform: "translate(38.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4536862,0.975609756 C0.203251418,0.975609756 0,1.19414634 0,1.46341463 L0,17.0731707 C0,17.342439 0.203251418,17.5609756 0.4536862,17.5609756 L7.71266541,17.5609756 C9.28151229,17.5609756 9.98109641,18.3131707 9.98109641,20 L9.98109641,1.9902439 C9.43032136,1.34146341 8.65270321,0.975609756 7.71266541,0.975609756 L0.4536862,0.975609756 Z",
    id: "Fill-566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.147448,7.60292683 L16.7863894,6.1395122 L15.4253308,7.60292683 L15.4253308,0.975609756 L18.147448,0.975609756 L18.147448,7.60292683 Z M20.8695652,1.46341463 C20.8695652,1.19414634 20.6663138,0.975609756 20.415879,0.975609756 L19.0548204,0.975609756 L19.0548204,0.487804878 C19.0548204,0.218536585 18.851569,0 18.6002268,0 L14.9716446,0 C14.7212098,0 14.5179584,0.218536585 14.5179584,0.487804878 L14.5179584,0.975609756 L13.1568998,0.975609756 C12.2159546,0.975609756 11.4383365,1.34146341 10.8884688,1.9902439 L10.8884688,20 C10.8884688,18.3141463 11.5880529,17.5609756 13.1568998,17.5609756 L20.415879,17.5609756 C20.6663138,17.5609756 20.8695652,17.342439 20.8695652,17.0731707 L20.8695652,1.46341463 Z",
    id: "Fill-567"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/content_icon.81d7906c7086f50baeebda331a730013.svg";